import React from 'react'
import { dateTimeFormat } from 'GenericForms/Helper'
import { useNavigate } from 'react-router-dom'
import BaseButton from './BaseButton'
import { Label, Row } from 'reactstrap'
import ESLogo from '../Media/Logo_Horizontal.png'
import ClientLogo from '../Media/client_logo.png';
import Defaultlogo from '../Media/Logo-01.jpg';
import env from 'environment_system/env_system'

const SystemUnderMaintenance = ({
    orgConfig
}: any) => {
    const Logo = ClientLogo || Defaultlogo;
    const navigate = useNavigate();
    return (
        <React.Fragment>
            <Row className="mb-3 mt-3">
                <div className='d-flex justify-content-center'>
                    <img
                        src={ESLogo}
                        alt="ecoSAIL"
                        height={50}
                    />
                </div>
            </Row>
            <Row className="mb-3">
                <div className="d-flex justify-content-center client-logo-container">
                    <img
                        src={Logo}
                        alt={`${env?.company_title}_logo`}
                        className="client-logo me-3"
                    />
                    <h2 className="mb-0 center-vertically">{env?.company_title}</h2>
                </div>
            </Row>
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 10,
                    pointerEvents: 'auto'
                }}
                id={`maintenance-div`}
            >
                <i
                    className="dripicons-warning text-danger cursor-not-allowed"
                    style={{
                        fontSize: '100px',
                        opacity: 1,
                        marginLeft: '40%',
                    }}
                    id={`maintenance-icon`}
                />
                <Label className="text-center icon_s22">
                    The system is currently under scheduled maintenance from <strong>{dateTimeFormat(orgConfig?.maintenance_start_time, false, false, true) ?? "-"}</strong>
                    &nbsp;to <strong>{dateTimeFormat(orgConfig?.maintenance_end_time, false, false, true) ?? "-"}</strong>.
                </Label>
                <div className='d-flex justify-content-center'>
                    <BaseButton
                        title="Logout"
                        onClick={() => navigate("/login", { replace: true })}
                        type="button"
                        variant="danger"
                        icon={<i className="bx bx-power-off" />}
                        loadingIcon={<i className="bx bx-hourglass bx-spin" />}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}

export default SystemUnderMaintenance